import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_PROJECT + name;
};

export let PathnameProject = {
  LANDING_PAGE: "/",
  LIST: "/list",
};
